// extracted by mini-css-extract-plugin
export default {"section":"Modal_section__HGK4y","modal":"Modal_modal__DJDMv"};